<script>
import { mapState } from 'vuex'
import Rainbow from '@/components/Rainbow.vue'
import BenefitBlock from '@/components/BenefitBlock.vue'
import PlanCards from '@/components/PlanCards.vue'
import FAQ from '@/components/FAQComponent.vue'
import track from '@/plugins/track'

export default {
  name: 'Home',
  props: ['anchor'],
  data() {
    return {
      videoOn: false,
    }
  },
  watch: {
    '$route': 'gotoSection',
  },
  components: {
    Rainbow,
    BenefitBlock,
    PlanCards,
    FAQ,
  },
  mounted() {
    if(this.anchor) {
      this.gotoSection()
    }
    else {
      this.$scrollTo(`#app`, 1, { easing: 'ease-in-out', })
    }
  },
  methods: {
    playVideo() {
      track({
        event: 'click',
        category: 'home',
        action: 'videoplay',
        label: 'VideoPlay',
      })
      this.videoOn = true
    },
    gotoSection() {
      if(!this.anchor) {
        this.$scrollTo(`#app`, 1000, { easing: 'ease-in-out', })
      }
      else {
        this.$scrollTo(`#${ this.anchor }`, 1000, { offset: 0, easing: 'ease-in-out', })
      }
    },
    morefaqClicked() {
      track({
        event: 'click',
        category: 'home',
        action: 'morefaqclicked',
        label: 'MoreFaqClicked',
      })
      this.$router.push({ name: 'FAQ' })
    }
  },
}
</script>

<template>
  <v-container fluid class="hero ma-auto mt-0 pa-0">
    <v-row>
      <v-col class="pa-0 ma-0">
        <v-container class="topheader my-0 py-0">
          <v-row>
            <v-col md="7" cols="12" class="my-0 py-0">
              <v-row class="mobile-hero">
                <v-col class="my-0 py-0">
                  <div class="mobile-hero-img"></div>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="start"
                class="text-left px-4"
              >
                <v-col class="mb-12">
                  <Rainbow class="ma-0 ml-1" thickness="8px" style="text-align: left; width: 30%;" />
                  <h1 class="mb-4">Healthy Pet&nbsp;+&trade;<br />Membership Plan</h1>
                  <p>Give your pet the veterinary care it needs to stay happy and healthy for a low monthly price. With <b>unlimited</b> pet exams<sup style="top: -8px !important;">1</sup> included and discounts on other services, caring for your pet has never been easier or more affordable.  Save <b>over $300</b> a year with our membership!</p>
                  <v-btn
                    class="py-8 px-8"
                    :to="{ path: `/plans/0`}"
                    large
                    color="primary"
                  >View Details</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <PlanCards />
        <v-container id="benefits" class="section inset">
          <v-row class="text-center">
            <v-col cols="12">
              <h1 class="mb-10">Why you'll love Healthy Pet&nbsp;+</h1>
              <v-img contain style="cursor: pointer;" v-if="!videoOn" @click="playVideo" class="mb-12 video" src="@/assets/img/video-placeholder.png" />
              <!-- <iframe title="vimeo-player" src="https://player.vimeo.com/video/445015936" width="640" height="480" frameborder="0" allowfullscreen></iframe> -->
              <video autoplay controls v-if="videoOn">
                <source src="https://media.liquidus.net/adbuilderprod/48441/PathwayHealthyPetProgram_1080p_60c72bcc_3abc_4ed0_b8ff_2921dd6ae553.mp4?sv=2017-07-29&sr=f&sig=35MA7ywD%2F%2BpZ5u%2BuQ2cN0X5tWJMYqwaY1VSR95pAEwA%3D&se=2021-05-01T13%3A31%3A31Z&sp=r" type="video/mp4">
                Your browser does not support the video tag.
              </video>
              <v-row class="mb-12" justify="center">
                  <BenefitBlock bgColor="ico-green" icon="MoreAffordableIcon" headline="More Affordable" subhead="Bundling your pet’s essential veterinary services will let you give your pet the best care for the lowest price." />
                  <BenefitBlock bgColor="ico-blue" icon="BetterCareIcon" headline="Better Care" subhead="More frequent trips to the vet mean preventable health problems can be detected and treated earlier." />
                  <BenefitBlock bgColor="ico-yellow" icon="EasierBudgetingIcon" headline="Easier Budgeting" subhead="Flat monthly payments make budgeting for your pet’s healthcare easier and more predictable." />
                  <BenefitBlock bgColor="ico-red" icon="LongerLifeIcon" headline="Longer Life" subhead="Receiving regular, comprehensive veterinary care can help your pet live a longer, happier and healthier life." />
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-row>
          <v-col class="faqbg">
            <h1 class="mt-4">Most Common FAQs</h1>
            <FAQ :numFaqs="10" id="faqs" class="pt-12" />
            <v-btn class="greenbtn mb-4" @click="morefaqClicked">View All FAQs</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
iframe {
  width:100%;
}
.hero, .mobile-hero-img {
  background-image: url('../assets/img/HPP_HomepageImage.jpg');
}
.section {
  min-height: 400px;
  margin: 50px auto;
}
.section h2 {
  margin-bottom: 20px;
}
.section p {
  margin-bottom: 40px;
}
video {
  width: 100%;
  height: auto;
  border: solid 2px $hpp-grey;
  margin-bottom: 20px;
}

.benefits-rainbow {
  width: 20%;
}
@media only screen and (max-width: 600px) {
  .benefits-rainbow {
    width: 50%;
  }
}

.faqbg {
  background-color: $hpp-lightblue;
}
</style>
